// Shared constants — single source of truth for the learn frontend

// ── Supported languages (mirrors backend SUPPORTED_LANGUAGES) ────────
export const SUPPORTED_LANGUAGES = ['en', 'es'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  en: 'English', es: 'Español',
}
